import * as Utils from './utils';
import * as Maps from './maps';
import * as FeatureVideos from './feature-videos';
import * as PrimaryVideos from './primary-videos';
import * as VR from './vr';
import * as AdvancedForms from './advanced-forms';
import axios from 'axios';
import imagesLoaded from 'imagesloaded';

const body = document.querySelector('body'),
    page = document.querySelector('.js-main-content');
    
let pageProcessing = false,
    pageLastUpdated = new Date().getTime(),
    replacePrimaryVideo = false;

export function init() {
    // If this page has the 'js-push-updates' class
    if (body.classList.contains('js-push-updates')) {
        const targetUrl = window.location.href;

        // Set 10 second interval to request an update version of the page contents
        setInterval(() => {
            // Only run our request if we're not already processing a page update
            if (!pageProcessing) {
                loadPage(targetUrl);
            }
        }, 10000);
    }
}

export function loadPage(pageUrl) {
    const entryId = body.dataset.id;

    // Set our page processing flag to true so we don't end up running multiple ajax requests 
    // while we're fetching and processing the results of a previous request.
    pageProcessing = true;

    // Run request to get updated entry content if it has been updated in the last 10 seconds
    axios
        .get(`/entry/last-updated?entryId=${entryId}&requestTime=${pageLastUpdated}`, {
            headers: { "X-Requested-With": "XMLHttpRequest" }
        })
        .then(function(response) {
            // If we get dateUpdated back then we know the page doesn't need updating
            if (typeof response.data.dateUpdated !== 'undefined') {
                pageProcessing = false;
                return false;
            }

            // Update pageLastUpdated to current timestamp
            pageLastUpdated = new Date().getTime();
                    
            showPage(response.request.response);
        })
        .catch(function(error) {
            console.error(error);
            pageProcessing = false;
        });
}

function showPage(contents) {
    // Convert string to nodes so we can find main content
    let contentHTML = stringToHTML(contents),
        mainContent = contentHTML.querySelector('.js-main-content');

    setPageContents(mainContent);

    // Reset images to avoid weird Safari bug
    if (Utils.browserDetection.safari || Utils.browserDetection.iOS) {
        let imgs = mainContent.getElementsByTagName('img');

        for (let i = 0; i < imgs.length; i++) {
            imgs[i].outerHTML = imgs[i].outerHTML;
        }
    }

    // Set our pageProcessing flag to false so we can run another request
    pageProcessing = false;

    // Update header if there's been a change to the cover image
    // If we have a cover image, set the header to sticky
    // othwerwise remove the sticky header class
    if (document.querySelector('.js-page-header .page-section--bannerImage')) {
        document.querySelector('.js-header').classList.remove('sticky');
    } else {
        document.querySelector('.js-header').classList.add('sticky');
    }

    // When all the images have loaded, fade it in
    imagesLoaded(page, () => {
        // Detect map within page
        if (document.querySelector('.js-map')) {
            // Test whether Maps API is already loaded
            if (typeof window.google !== 'undefined' || window.google === undefined || window.google === 'undefined' ) {
                // Load the API script
                loadJS("https://maps.googleapis.com/maps/api/js?key=AIzaSyAbSsLTuvEL7ZcNhqsBb3E_Slu95uScI5Q");

                // Set check running
                let mapsCheck = setInterval(function(){
                    if (typeof google === 'object' && typeof google.maps === 'object') {
                        // Get map element
                        const mapEl = document.querySelector('.js-map');

                        // Build map
                        Maps.buildEventMap(mapEl);

                        // Break interval
                        clearInterval(mapsCheck);
                    }
                }, 100);
            }
        }

        // Advanced Forms
        if (document.querySelector('.js-form-block')) {
            AdvancedForms.init();
        }

        // 360 VR
        if (document.querySelectorAll('.js-360-vr').length && window.pannellum) {
            VR.init();
        }

        FeatureVideos.init();
        
        if (replacePrimaryVideo) {
            PrimaryVideos.init();
        }

        // Run element transitions
        Utils.animateInViewEls('.js-watch', 'in-view', 0.075);

        replacePrimaryVideo = false;
    });
}

function setPageContents(contents) {
    // Determine which parts of the page need updating based on whether the
    // .js-primary-video has changed or not
    // If it has changed, then the whole page content can be refreshed,
    // If not change the .js-page-header and .js-page-content only
    const pageContent = {
            header: document.querySelector('.js-page-header'),
            blockContent: document.querySelector('.js-page-block-content'),
            primaryVideo: document.querySelector('.js-primary-video iframe'),
        },
        updatedContent = {
            header: contents.querySelector('.js-page-header'),
            blockContent: contents.querySelector('.js-page-block-content'),
            primaryVideo: contents.querySelector('.js-primary-video iframe'),
        };

    // Attempt match of primary video iframe src attributes without querystrings
    if (
        typeof pageContent.primaryVideo !== "undefined" &&
        typeof updatedContent.primaryVideo  !== "undefined" &&
        pageContent.primaryVideo.src.split('?')[0] == updatedContent.primaryVideo.src.split('?')[0]
    ) {
        // Update page header and block content only
        pageContent.header.innerHTML = '';
        pageContent.blockContent.innerHTML = '';
        
        pageContent.header.appendChild(updatedContent.header);
        pageContent.blockContent.appendChild(updatedContent.blockContent);
    } else {
        // Update entire page
        page.innerHTML = '';
    
        // Insert contents into the container
        page.appendChild(contents);
        
        replacePrimaryVideo = true;
    }
}

function parserSupport() {
    if (!window.DOMParser) return false;

    var parser = new DOMParser();
    
    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }
    return true;
}

function stringToHTML(str) {
    // If DOMParser is supported, use it
    if (parserSupport()) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(str, 'text/html');
        return doc.body;
    }

    // Otherwise, fallback to old-school method
    var dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;
}
